<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M29.334 16c0 7.364-5.97 13.333-13.334 13.333-7.363 0-13.333-5.97-13.333-13.333C2.667 8.636 8.637 2.667 16 2.667c7.364 0 13.334 5.97 13.334 13.333zM16 17.333a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666zm0 2a3.333 3.333 0 100-6.666 3.333 3.333 0 000 6.666zm-7.314-4.12a1.228 1.228 0 00.048-.21 7.334 7.334 0 016.27-6.269 1.216 1.216 0 00.21-.048c.447-.145.786-.54.786-1.02 0-.552-.449-1.005-.998-.946l-.27.033-.03.004a9.333 9.333 0 00-7.944 7.945l-.004.03c-.013.09-.024.18-.034.27-.059.55.395.998.947.998.48 0 .874-.339 1.02-.786z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsCdFilled'
}
</script>
